import Vue from 'vue'
import Router from 'vue-router'
import auth from '../src/api/auth'
import Login from '../src/components/app/account/login.vue'
import Home from '../src/components/app/home/index.vue'
import Dot9BiletListe from '../src/components/app/bilet/biletraporu.vue'
import Dot9UcusRaporu from '../src/components/app/bilet/ucusraporu.vue'
import Dot9FirmaBilgileri from '../src/components/app/firma/firmabilgileri.vue'
import Dot9EkstreHesap from '../src/components/app/ekstreler/hesabagore.vue'
import Dot9VizeRaporu from '../src/components/app/vize/vizeraporu.vue'
import Dot9FaturaListesi from '../src/components/app/fatura/faturalistesi.vue'
import Dot9EncokGidilen from '../src/components/app/bilet/encokgidilenyerler.vue'
import Dot9ClassRaporu from '../src/components/app/bilet/classraporu.vue'
import Dot9DetayliBooking from '../src/components/app/bilet/detaylibookingraporu.vue'
import Dot9SegmentRaporu from '../src/components/app/bilet/segmentraporu.vue'
import Dot9SummaryRaporu from '../src/components/app/bilet/summaryrapor.vue'
import Dot9BiletDetay from '../src/components/app/bilet/biletdetay.vue'

import Confirm from '../src/components/app/account/confirm.vue'
import MusteriIndex from '../src/components/app/musteri/index.vue'
import SatilanUrunler from '../src/components/app/urun/satilanurunler.vue'
import DestekTalebi from '../src/components/app/destek/index.vue'
import SorunDetay from '../src/components/app/destek/sorundetay.vue'
import SorunDetayNew from '../src/components/app/destek/sorundetaynew.vue'
import SorunDestekIslem from '../src/components/app/destek/sorundestekislem.vue'
import SorunIslem from '../src/components/app/destek/sorunislem.vue'
import Takvim from '../src/components/app/takvimv2/takvim.vue'
// import TakvimIslem from '../src/components/app/takvim/takvimislem.vue'
import Rapor from '../src/components/app/rapor/index.vue'
import RaporDetay from '../src/components/app/rapor/rapordetay.vue'
import RaporDetayDestek from '../src/components/app/rapor/rapordetaydestek.vue'
//next ile ilgili
import webSayfalari from '../src/components/app/next/websayfalari.vue'
import MusteriIslem from '../src/components/app/musteri/musteriislem.vue'
import Anasirket from '../src/components/app/account/anasirket.vue'
import LoginUye from '../src/components/app/account/uye/index.vue'
import UyeDetay from '../src/components/app/account/uye/detay.vue'
import UyeYeni from '../src/components/app/account/uye/yeni.vue'
import UyeYetkiGrup from '../src/components/app/account/uye/yetkigrup.vue'
import UyeYetkiGrupList from '../src/components/app/account/uye/yetkigruplistesi.vue'
import Loginyeni from '../src/components/app/account/login1.vue'


//Bilet Linkler
import BiletIndex from '../src/components/app/bilet/yeni.vue'
import BiletIade from '../src/components/app/bilet/biletiade.vue'
import BiletListe from '../src/components/app/bilet/index.vue'
import THYAktarim from '../src/components/app/bilet/aktarimbilet/thyaktarim.vue'
import AmadeusAktarim from '../src/components/app/bilet/aktarimbilet/amadeusaktarim.vue'
import baseaktar from '../src/components/app/bilet/aktarimbilet/baseaktarim.vue'
import pegasusaktar from '../src/components/app/bilet/aktarimbilet/pegasusaktarim.vue'
import onuraktar from '../src/components/app/bilet/aktarimbilet/onurairaktarim.vue'
import iatiaktar from '../src/components/app/bilet/aktarimbilet/iatiaktarim.vue'
import sunexpressaktar from '../src/components/app/bilet/aktarimbilet/sunexpressaktarim.vue'
import galileoaktar from '../src/components/app/bilet/aktarimbilet/galileoaktarim.vue'
import sabreaktar from '../src/components/app/bilet/aktarimbilet/sabreaktarim.vue'
import bookingagoraaktar from '../src/components/app/bilet/aktarimbilet/bookingagoraaktarim.vue'
import BiletAktarim from '../src/components/app/bilet/aktarimlar.vue'
import BiletTanim from '../src/components/app/bilet/tanimlamalar.vue'
import Parkur from '../src/components/app/bilet/parkur.vue'
import BiletGunlukSatis from '../src/components/app/bilet/gunluksatisraporu.vue'
import BiletGelirDag from '../src/components/app/bilet/gelirdagilimiraporu.vue'
import TkDevreRaporu from '../src/components/app/bilet/raporlar/tkdevreraporu.vue'
import GenelDevreRaporu from '../src/components/app/bilet/raporlar/geneldevreraporu.vue'
import GenelAmacliRaporu from '../src/components/app/bilet/raporlar/genelamacli.vue'
import NonIAataDevreRaporu from '../src/components/app/bilet/raporlar/noniatadevreraporu.vue'
import BspDevreRaporu from '../src/components/app/bilet/raporlar/bspdevreraporu.vue'


import BiletGenelParametreler from '../src/components/app/bilet/genelparametreler.vue'
import BiletRaporParametreler from '../src/components/app/bilet/raporparametre.vue'



//Cari Linkler
import cari from '../src/components/app/cari/form.vue'
import goster from '../src/components/app/cari/goster.vue'
import duzenle from '../src/components/app/cari/duzenle.vue'
import yeni from '../src/components/app/cari/yeni.vue'
import tumkayitlar from '../src/components/app/cari/tumkayitlar.vue'
import CariIndex from '../src/components/app/cari/index.vue'

import CariHareketIndex from '../src/components/app/carihareketler/index.vue'
import CariHareketYeni from '../src/components/app/carihareketler/yeni.vue'
import CariHareketDuzenle from '../src/components/app/carihareketler/duzenle.vue'
import Parametreler from '../src/components/app/parametreler/genelparametreler.vue'
import MasrafMerkezi from '../src/components/app/parametreler/masrafmerkezi.vue'
import Referans from '../src/components/app/parametreler/referans.vue'
import Evrak from '../src/components/app/parametreler/evrak.vue'
import Sirket from '../src/components/app/parametreler/sirket.vue'
import Bolum from '../src/components/app/parametreler/bolum.vue'
import Gib from '../src/components/app/parametreler/gib.vue'
import Gibearsiv from '../src/components/app/parametreler/gibseriearsiv.vue'
import HesapGurubu from '../src/components/app/parametreler/hesapgurubu.vue'
import Efaturadip from '../src/components/app/parametreler/efaturadip.vue'
import Webadresi from '../src/components/app/parametreler/webadresi.vue'
import Odemearaci from '../src/components/app/parametreler/odemearaci.vue'
import Odemesekliaciklama from '../src/components/app/parametreler/odemesekliaciklama.vue'
import SerbestFatura from '../src/components/app/faturalar/serbestfatura.vue'
import SerbestFaturaYeni from '../src/components/app/fatura/serbestfatura.vue'

import FaturaListesi from '../src/components/app/faturalar/faturalistesi.vue'
import FaturaBasma from '../src/components/app/fatura/faturabasma.vue'


import EntegrasyonIndex from '../src/components/app/entegrasyon/index.vue'

import Deneme1 from '../src/components/app/customcomp/deneme.vue'
import BankaPos from '../src/components/app/parametreler/bankapos.vue'
import YeniPos from '../src/components/app/parametreler/yenipos.vue'
import Analiz from '../src/components/app/parametreler/analiz.vue'
import Banka from '../src/components/app/parametreler/banka.vue'
import Doviz from '../src/components/app/parametreler/doviz.vue'
import Firma from '../src/components/app/parametreler/firma.vue'
import BorcluListesi from '../src/components/app/diger/borclulistesi.vue'
import MutabakatMektubu from '../src/components/app/diger/mutabakatmektubu.vue'

import KasaListesi from '../src/components/app/diger/kasaraporu.vue'
import CaritanimGenel from '../src/components/app/tanimlamalar/genel.vue'
import CaritanimSirket from '../src/components/app/tanimlamalar/sirket.vue'
import MizanCari from '../src/components/app/mizan/carihesap.vue'
import MizanMasraf from '../src/components/app/mizan/masrafmerkezi.vue'
import MizanReferans from '../src/components/app/mizan/referans.vue'
import MizanDoviz from '../src/components/app/mizan/doviz.vue'
import EkstreHesap from '../src/components/app/ekstreler/hesabagore.vue'
import EkstreTarih from '../src/components/app/ekstreler/tarihegore.vue'
import EkstreReferans from '../src/components/app/ekstreler/referansagore.vue'
import EkstreMasraf from '../src/components/app/ekstreler/masrafmerkezinegore.vue'
import EkstreFirmaKart from '../src/components/app/ekstreler/firmakartinagore.vue'
import MusteriPersonel from '../src/components/app/ekstralar/musteri-personel.vue'
import Profilsablon from '../src/components/app/ekstralar/profilsablon.vue'
import Profilsablonveri from '../src/components/app/ekstralar/sablonverigirisi.vue'
import FaturaListesiYeni from '../src/components/app/fatura/faturalistesi.vue'
import GelenFaturaListesi from '../src/components/app/fatura/gelenfaturalistesi.vue'

import FaturaTanimlamalarYeni from '../src/components/app/fatura/tanimlamalar.vue'
import Faturaxslt from '../src/components/app/fatura/faturaxslt.vue'
import FaturadizaynTanimla from '../src/components/app/fatura/faturadizayntanimlama.vue'
import FaturaDetay from '../src/components/app/fatura/faturadetay.vue'




//Coper başla
import saticitanit from '../src/components/app/coper/page/tanitimlar/saticitanit.vue'
import saticilist from '../src/components/app/coper/page/tanitimlar/saticilist.vue'
import saticilar from '../src/components/app/coper/page/tanitimlar/saticilar.vue'

import saticitumkayitlar from '../src/components/app/coper/page/tanitimlar/saticitumkayitlar.vue'
import rezervasyon from '../src/components/app/coper/page/rezervasyon/rezervasyon.vue'
import coperSirket from '../src/components/app/coper/page/tanitimlar/sirket.vue'

//import rezervasyonyeni from '../src/components/app/coper/page/rezervasyon/rezervasyon.vue'









//Coper bitiş
//EFatura Başla
import efatura from '../src/components/app/efatura/efatura.vue'
//EFatura Bitiş


Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login/:id', name: 'login', component: Login },
    { path: '/', name: 'home', component: Home , meta: { requiresAuth: true } },
    { path: '/bilet/biletraporu', name: 'dot9-biletraporu', component: Dot9BiletListe, meta: { requiresAuth: true } },
    { path: '/bilet/ucusraporu', name: 'dot9-ucusraporu', component: Dot9UcusRaporu, meta: { requiresAuth: true } },
    { path: '/firma/firmabilgileri', name: 'dot9-firmabilgileri', component: Dot9FirmaBilgileri, meta: { requiresAuth: true } },
    { path: '/ekstreler/hesabagore', name: 'dot9-ekstrelistesi', component: Dot9EkstreHesap, meta: { requiresAuth: true } },
    { path: '/vize/vizeraporu', name: 'dot9-vizeraporu', component: Dot9VizeRaporu, meta: { requiresAuth: true } },
    { path: '/fatura/faturalistesi', name: 'dot9-faturalistesi', component: Dot9FaturaListesi, meta: { requiresAuth: true } },
    { path: '/bilet/encokgidilenyerler', name: 'dot9-encokgidilenyerler', component: Dot9EncokGidilen, meta: { requiresAuth: true } },
    { path: '/bilet/classraporu', name: 'dot9-classraporu', component: Dot9ClassRaporu, meta: { requiresAuth: true } },
    { path: '/bilet/detaylibookingraporu', name: 'dot9-detaylibooking', component: Dot9DetayliBooking, meta: { requiresAuth: true } },
    { path: '/bilet/segmentraporu', name: 'dot9-segmentraporu', component: Dot9SegmentRaporu, meta: { requiresAuth: true } },
    { path: '/bilet/summaryrapor', name: 'dot9-summaryrapor', component: Dot9SummaryRaporu, meta: { requiresAuth: true } },
    { path: '/bilet/biletdetay/:id', name: 'dot9-biletdetay', component: Dot9BiletDetay, meta: { requiresAuth: true } },



    { path: '/confirm/:id', name: 'confirm', component: Confirm },
    { path: '/musteri/index', name: 'musteri-listesi', component: MusteriIndex , meta: { requiresAuth: true }  },
    { path: '/musteri/musteriislem/:id', name: 'musteri-musteriislem', component: MusteriIslem , meta: { requiresAuth: true }  },

    { path: '/urun/satilanurunler', name: 'satilanurunler', component: SatilanUrunler , meta: { requiresAuth: true }  },
    { path: '/destek/index', name: 'destek-talepleri', component: DestekTalebi , meta: { requiresAuth: true }  },
    { path: '/destek/sorundetay/:id', name: 'sorun-detay', component: SorunDetay , meta: { requiresAuth: true }  },
    { path: '/destek/sorundetaynew', name: 'sorun-detay-new', component: SorunDetayNew , meta: { requiresAuth: true }  },
    { path: '/destek/sorundestekislem/:id', name: 'sorun-destek-islem', component: SorunDestekIslem , meta: { requiresAuth: true }  },
    { path: '/destek/sorunislem/:id', name: 'sorun-islem', component: SorunIslem , meta: { requiresAuth: true }  },
    { path: '/takvimv2/takvim', name: 'takvim', component: Takvim , meta: { requiresAuth: true }  },
    // { path: '/takvim/takvimislem/:id', name: 'takvim-islem', component: TakvimIslem , meta: { requiresAuth: true }  },
    { path: '/rapor/index', name: 'rapor', component: Rapor , meta: { requiresAuth: true }  },
    { path: '/rapor/rapordetay', name: 'rapor-detay', component: RaporDetay , meta: { requiresAuth: true }  },
    { path: '/rapor/rapordetaydestek', name: 'rapor-detay-destek', component: RaporDetayDestek , meta: { requiresAuth: true }  },








    { path: '/next/websayfalari', name: 'web-sayfalari', component: webSayfalari , meta: { requiresAuth: true }  },





    { path: '/anasirket', name: 'anasirket', component: Anasirket },
    { path: '/uye/index', name: 'login-uye', component: LoginUye },
    { path: '/uye/yetkigrup/:id', name: 'login-yetkigrup', component: UyeYetkiGrup },
    { path: '/uye/yetkigruplistesi', name: 'login-yetkigruplist', component: UyeYetkiGrupList },

    { path: '/uye/detay/:id', name: 'uye-detay', component: UyeDetay },
    { path: '/uye/yeni', name: 'uye-yeni', component: UyeYeni },

    { path: '/loginyeni', name: 'loginyeni', component: Loginyeni },

    { path: '/cari/form', name: 'cari', component: cari, meta: { requiresAuth: true }  },
    { path: '/cari/goster/:id', name: 'goster', component: goster, meta: { requiresAuth: true }  },
    { path: '/cari/duzenle/:id', name: 'duzenle', component: duzenle, meta: { requiresAuth: true }  },
    { path: '/cari/yeni', name: 'yeni', component: yeni, meta: { requiresAuth: true }  },
    { path: '/cari/tumkayitlar', name: 'tumkayitlar', component: tumkayitlar, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel', name: 'genelparametreler', component: Parametreler, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/referans', name: 'referans', component: Referans, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/doviz', name: 'doviz', component: Doviz, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/evrak', name: 'evrak', component: Evrak, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/analiz', name: 'analiz', component: Analiz, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/banka', name: 'banka', component: Banka, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/sirket', name: 'sirket', component: Sirket, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/bolum', name: 'bolum', component: Bolum, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/gib', name: 'gib', component: Gib, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/gibseriearsiv', name: 'gibseriearsiv', component: Gibearsiv, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/hesapgurubu', name: 'hesapgurubu', component: HesapGurubu, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/efaturadip', name: 'efaturadip', component: Efaturadip, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/webadresi', name: 'webadresi', component: Webadresi, meta: { requiresAuth: true }  },
    { path: '/customcomp/deneme', name: 'deneme', component: Deneme1, meta: { requiresAuth: true }  },

    { path: '/parametreler/genel/odemearaci', name: 'odemearaci', component: Odemearaci, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/odemesekliaciklama', name: 'odemesekliaciklama', component: Odemesekliaciklama
    , meta: { requiresAuth: true }  },
    { path: '/faturalar/faturalistesi', name: 'fatura-listesi', component: FaturaListesi, meta: { requiresAuth: true } },
    { path: '/fatura/faturabasma', name: 'fatura-basma', component: FaturaBasma, meta: { requiresAuth: true } },

    { path: '/faturalar/serbestfatura/:id', name: 'fatura-serbest', component: SerbestFatura, meta: { requiresAuth: true } },
    { path: '/ekstralar/musteripersonel', name: 'ekstra-musteri', component: MusteriPersonel, meta: { requiresAuth: true }  },
    { path: '/ekstralar/profilsablon', name: 'ekstralar-profilsablon', component: Profilsablon, meta: { requiresAuth: true }  },
    { path: '/ekstralar/sablonverigirisi', name: 'ekstralar-verigirisi', component: Profilsablonveri, meta: { requiresAuth: true }  },







    { path: '/parametreler/genel/bankapos', name: 'bankapos', component: BankaPos, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/bankapos/:id', name: 'yenipos', component: YeniPos, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/firma', name: 'firma', component: Firma, meta: { requiresAuth: true }  },
    { path: '/parametreler/genel/masrafmerkezi', name: 'masrafmerkezi', component: MasrafMerkezi, meta: { requiresAuth: true } },
    { path: '/cari/index', name: 'cari-index', component: CariIndex, meta: { requiresAuth: true } },

    { path: '/carihareketler/index', name: 'carihareketler-index', component: CariHareketIndex, meta: { requiresAuth: true } },
    { path: '/carihareketler/yeni', name: 'carihareketler-yeni', component: CariHareketYeni, meta: { requiresAuth: true } },
    { path: '/carihareketler/duzenle/:id', name: 'carihareketler-duzenle', component: CariHareketDuzenle, meta: { requiresAuth: true } },
    { path: '/diger/mutabakatmektubu', name: 'mutabakat-mektubu', component: MutabakatMektubu, meta: { requiresAuth: true }  },
    { path: '/entegrasyon/index', name: 'entegrasyon-index', component: EntegrasyonIndex, meta: { requiresAuth: true }  },

    { path: '/diger/borclulistesi', name: 'borclu-liste', component: BorcluListesi, meta: { requiresAuth: true }  },
    { path: '/diger/kasaraporu', name: 'kasa-liste', component: KasaListesi, meta: { requiresAuth: true }  },
    { path: '/tanimlamalar/genel', name: 'parametre-genel', component: CaritanimGenel, meta: { requiresAuth: true }  },
    { path: '/tanimlamalar/sirket', name: 'parametre-sirket', component: CaritanimSirket, meta: { requiresAuth: true }  },
    { path: '/mizan/carihesap', name: 'mizan-carihesap', component: MizanCari, meta: { requiresAuth: true }  },
    { path: '/mizan/masrafmerkezi', name: 'mizan-masrafmerkezi', component: MizanMasraf, meta: { requiresAuth: true }  },
    { path: '/mizan/referans', name: 'mizan-referans', component: MizanReferans, meta: { requiresAuth: true }  },
    { path: '/mizan/doviz', name: 'mizan-doviz', component: MizanDoviz, meta: { requiresAuth: true }  },
    { path: '/ekstreler/hesabagore', name: 'ekstre-hesap', component: EkstreHesap, meta: { requiresAuth: true }  },
    { path: '/ekstreler/tarihegore', name: 'ekstre-tarih', component: EkstreTarih, meta: { requiresAuth: true }  },
    { path: '/ekstreler/referansagore', name: 'ekstre-referans', component: EkstreReferans, meta: { requiresAuth: true }  },
    { path: '/ekstreler/masrafmerkezinegore', name: 'ekstre-masraf', component: EkstreMasraf, meta: { requiresAuth: true }  },
    { path: '/ekstreler/firmakartinagore', name: 'ekstre-firmakart', component: EkstreFirmaKart, meta: { requiresAuth: true }  },
    { path: '/bilet/yeni/:id', name: 'bilet-yeni', component: BiletIndex, meta: { requiresAuth: true } },
    { path: '/bilet/biletiade/:id', name: 'bilet-iade', component: BiletIade, meta: { requiresAuth: true } },
    { path: '/bilet/tanimlamalar', name: 'bilet-tanimlamalar', component: BiletTanim, meta: { requiresAuth: true } },
    { path: '/bilet/genelparametreler', name: 'bilet-genelparametreler', component: BiletGenelParametreler, meta: { requiresAuth: true } },
    { path: '/bilet/raporparametre', name: 'bilet-raporparametre', component: BiletRaporParametreler, meta: { requiresAuth: true } },

    { path: '/bilet/index', name: 'bilet-listesi', component: BiletListe, meta: { requiresAuth: true } },
    { path: '/bilet/aktarimlar', name: 'bilet-aktarimlar', component: BiletAktarim, meta: { requiresAuth: true } },
    { path: '/bilet/parkur', name: 'parkur', component: Parkur, meta: { requiresAuth: true }  },
    { path: '/bilet/gunluksatisraporu', name: 'bilet-gunluksatisraporu', component: BiletGunlukSatis, meta: { requiresAuth: true }  },
    { path: '/bilet/gelirdagilimiraporu', name: 'bilet-gelirdagilimiraporu', component: BiletGelirDag, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/tkdevreraporu', name: 'bilet-tkdevreraporu', component: TkDevreRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/geneldevreraporu', name: 'bilet-geneldevreraporu', component: GenelDevreRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/genelamacli', name: 'bilet-genelamacliraporu', component: GenelAmacliRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/noniatadevreraporu', name: 'bilet-noniatadevreraporu', component: NonIAataDevreRaporu, meta: { requiresAuth: true }  },
    { path: '/bilet/raporlar/bspdevreraporu', name: 'bilet-bspdevreraporu', component: BspDevreRaporu, meta: { requiresAuth: true }  },

    { path: '/bilet/biletaktarim/thyaktarim', name: 'thy-aktarim', component: THYAktarim, meta: { requiresAuth: true } },
    { path: '/bilet/aktarimbilet/amadeusaktarim', name: 'amadeus-aktarim', component: AmadeusAktarim, meta: { requiresAuth: true } },
    { path: '/bilet/aktarimbilet/pegasusaktarim', name: 'pegasusaktar', component: pegasusaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/baseaktarim', name: 'baseaktar', component: baseaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/onurairaktarim', name: 'onurairaktar', component: onuraktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/sunexpressaktar', name: 'sunexpressaktar', component: sunexpressaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/iatiaktar', name: 'iatiaktar', component: iatiaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/galileoaktar', name: 'galileoaktar', component: galileoaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/sabreaktar', name: 'sabreaktar', component: sabreaktar, meta: { requiresAuth: true }  },
    { path: '/bilet/aktarimbilet/bookingagoraaktar', name: 'bookingagoraaktar', component: bookingagoraaktar, meta: { requiresAuth: true }  },

//fatura
{ path: '/fatura/faturadetay/:id', name: 'faturadetay', component: FaturaDetay, meta: { requiresAuth: true }  },
{ path: '/fatura/faturalistesi', name: 'faturalistesi', component: FaturaListesiYeni, meta: { requiresAuth: true }  },
{ path: '/fatura/gelenfaturalistesi', name: 'gelenfaturalistesi', component: GelenFaturaListesi, meta: { requiresAuth: true }  },
{ path: '/fatura/serbestfatura/:id', name: 'fatura-serbestyeni', component: SerbestFaturaYeni, meta: { requiresAuth: true } },

{ path: '/fatura/tanimlamalar', name: 'faturatanimlamalar', component: FaturaTanimlamalarYeni, meta: { requiresAuth: true }  },
{ path: '/fatura/faturaxslt', name: 'faturaxslt', component: Faturaxslt, meta: { requiresAuth: true }  },
{ path: '/fatura/faturadizayntanimlama', name: 'faturadizayntanimlama', component: FaturadizaynTanimla, meta: { requiresAuth: true }  },


    //Coper Başla
    { path: '/coper/saticitanit/:id/:saticiTipi', name: 'saticitanit', component: saticitanit, meta: { requiresAuth: true }  },
    { path: '/coper/saticilist', name: 'saticilist', component: saticilist, meta: { requiresAuth: true }  },
    { path: '/coper/saticilar', name: 'saticilar', component: saticilar, meta: { requiresAuth: true }  },

    { path: '/coper/saticitumkayitlar/:saticiTipi', name: 'saticitumkayitlar', component: saticitumkayitlar, meta: { requiresAuth: true }  },
    { path: '/coper/rezervasyon/:id', name: 'rezervasyon', component: rezervasyon, meta: { requiresAuth: true }  },
    { path: '/coper/rezervasyonyeni', name: 'rezervasyonyeni', component: rezervasyon, meta: { requiresAuth: true }  },
    { path: '/coper/coperSirket', name: 'coperSirket', component: coperSirket, meta: { requiresAuth: true }  },

    //Coper Bitiş
    //EFatura Başla
    { path: '/efatura/efatura', name: 'efatura', component: efatura, meta: { requiresAuth: true }  },





    //EFatura Bit

  ]
})


router.beforeEach((to, from, next) => {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

  //console.log('params'+to.params.id)
  //console.log('params2'+from.params.id)
  //console.log('params3'+next)



      if (to.matched.length === 0) { // route yok

  console.log('router yok'+from.params.id)


if (from.params.id!=undefined) {
   next({
           path: '/login/'+from.params.id///+credentials.Id // BB742AA6-92D4-48EE-83AE-BDA7B4C70BAF'
         })

} else {

  next({
    path: '/login/'+credentials.Id///+credentials.Id // BB742AA6-92D4-48EE-83AE-BDA7B4C70BAF'
  })


}




      } else {
        console.log('router var')
        if (to.matched.some(record => record.meta.requiresAuth)) {

          if (!auth.checkAuth()) {

           console.log('checkout'+credentials.Id)

            router.push({
              path: '/login/'+credentials.Id//=BB742AA6-92D4-48EE-83AE-BDA7B4C70BAF'
            })

          } else {
         console.log('check oldu devam'+to.fullPath)

            next()
          }

        } else {
          console.log('auth istemiyoruz '+to.fullPath)


         next()
        }
      next()
    }



})




router.afterEach(function (val) {

  var routem=[]
  routem= val.fullPath.split('/')

  if (!auth.checkAuth()) {
   window.localStorage.removeItem('tokenreport')
 //window.localStorage.removeItem('credentials')

  if (routem[1]=='confirm') {

  } else {

   router.push({
     path: '/login'
   })
  }

  }
})


export default router